var _rect, _rect2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 13.786,
    rx: 1.75,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "th_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 13.786,
    rx: 1.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#th_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.857h20V0H0v2.857zM0 14.286h20v-2.857H0v2.857z",
    fill: "#F12532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.524h20V4.762H0v4.762z",
    fill: "#322B6C"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4yNSIgeT0iMC4yNSIgd2lkdGg9IjE5LjUiIGhlaWdodD0iMTMuNzg1NyIgcng9IjEuNzUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNGNUY1RjUiIHN0cm9rZS13aWR0aD0iMC41Ii8+CjxtYXNrIGlkPSJtYXNrMCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjE1Ij4KPHJlY3QgeD0iMC4yNSIgeT0iMC4yNSIgd2lkdGg9IjE5LjUiIGhlaWdodD0iMTMuNzg1NyIgcng9IjEuNzUiIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDIuODU3MTRIMjBWMEgwVjIuODU3MTRaIiBmaWxsPSIjRjEyNTMyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxNC4yODU3SDIwVjExLjQyODZIMFYxNC4yODU3WiIgZmlsbD0iI0YxMjUzMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgOS41MjM4N0gyMFY0Ljc2MTk2SDBWOS41MjM4N1oiIGZpbGw9IiMzMjJCNkMiLz4KPC9nPgo8L3N2Zz4K";
export { SvgTh as ReactComponent };